var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside:[capture]",
          value: _vm.onClickOutside,
          expression: "onClickOutside",
          arg: _vm.capture
        },
        {
          name: "click-outside",
          rawName: "v-click-outside:[capture].mousedown",
          value: _vm.onClickOutside,
          expression: "onClickOutside",
          arg: _vm.capture,
          modifiers: { mousedown: true }
        },
        {
          name: "click-outside",
          rawName: "v-click-outside:[capture].touchstart",
          value: _vm.onClickOutside,
          expression: "onClickOutside",
          arg: _vm.capture,
          modifiers: { touchstart: true }
        }
      ],
      class: _vm.classes
    },
    [
      _c(
        "div",
        {
          ref: "reference",
          class: _vm.selectionCls,
          attrs: { tabindex: _vm.selectTabindex },
          on: {
            blur: _vm.toggleHeaderFocus,
            focus: _vm.toggleHeaderFocus,
            click: _vm.toggleMenu,
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                return _vm.handleKeydown.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleKeydown.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.handleKeydown.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.handleKeydown.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                return _vm.handleKeydown.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                    "Backspace",
                    "Delete",
                    "Del"
                  ])
                ) {
                  return null
                }
                return _vm.handleKeydown.apply(null, arguments)
              }
            ],
            mouseenter: function($event) {
              _vm.hasMouseHoverHead = true
            },
            mouseleave: function($event) {
              _vm.hasMouseHoverHead = false
            }
          }
        },
        [
          _vm._t("input", function() {
            return [
              _c("input", {
                attrs: { type: "hidden", name: _vm.name },
                domProps: { value: _vm.publicValue }
              }),
              _vm._v(" "),
              _c(
                "select-head",
                {
                  attrs: {
                    filterable: _vm.filterable,
                    multiple: _vm.multiple,
                    values: _vm.values,
                    clearable: _vm.canBeCleared,
                    prefix: _vm.prefix,
                    disabled: _vm.itemDisabled,
                    remote: _vm.remote,
                    "input-element-id": _vm.elementId,
                    "initial-label": _vm.initialLabel,
                    placeholder: _vm.placeholder,
                    "query-prop": _vm.query,
                    "max-tag-count": _vm.maxTagCount,
                    "max-tag-placeholder": _vm.maxTagPlaceholder,
                    "allow-create": _vm.allowCreate,
                    "show-create-item": _vm.showCreateItem
                  },
                  on: {
                    "on-query-change": _vm.onQueryChange,
                    "on-input-focus": function($event) {
                      _vm.isFocused = true
                    },
                    "on-input-blur": function($event) {
                      _vm.isFocused = false
                    },
                    "on-clear": _vm.clearSingleSelect,
                    "on-enter": _vm.handleCreateItem
                  }
                },
                [_vm._t("prefix", null, { slot: "prefix" })],
                2
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "transition-drop" } },
        [
          _c(
            "Drop",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dropVisible,
                  expression: "dropVisible"
                },
                { name: "transfer-dom", rawName: "v-transfer-dom" }
              ],
              ref: "dropdown",
              class: _vm.dropdownCls,
              attrs: {
                placement: _vm.placement,
                "data-transfer": _vm.transfer,
                transfer: _vm.transfer,
                eventsEnabled: _vm.eventsEnabled
              }
            },
            [
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showNotFoundLabel && !_vm.allowCreate,
                      expression: "showNotFoundLabel && !allowCreate"
                    }
                  ],
                  class: [_vm.prefixCls + "-not-found"]
                },
                [_c("li", [_vm._v(_vm._s(_vm.localeNotFoundText))])]
              ),
              _vm._v(" "),
              !_vm.remote || (_vm.remote && !_vm.loading)
                ? _c(
                    "functional-options",
                    {
                      class: _vm.prefixCls + "-dropdown-list",
                      attrs: {
                        options: _vm.selectOptions,
                        "slot-update-hook": _vm.updateSlotOptions,
                        "slot-options": _vm.slotOptions
                      }
                    },
                    [
                      _vm.showCreateItem
                        ? _c(
                            "li",
                            {
                              class: _vm.prefixCls + "-item",
                              on: { click: _vm.handleCreateItem }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.query) +
                                  "\n                    "
                              ),
                              _c("Icon", {
                                class: _vm.prefixCls + "-item-enter",
                                attrs: { type: "md-return-left" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _c("ul", { class: _vm.prefixCls + "-dropdown-list" }, [
                    _vm.showCreateItem
                      ? _c(
                          "li",
                          {
                            class: _vm.prefixCls + "-item",
                            on: { click: _vm.handleCreateItem }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.query) +
                                "\n                    "
                            ),
                            _c("Icon", {
                              class: _vm.prefixCls + "-item-enter",
                              attrs: { type: "md-return-left" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  class: [_vm.prefixCls + "-loading"]
                },
                [_vm._v(_vm._s(_vm.localeLoadingText))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-134d7ec5", { render: render, staticRenderFns: staticRenderFns })
  }
}